import script from "./daily-verse-card.vue?vue&type=script&setup=true&lang=js"
export * from "./daily-verse-card.vue?vue&type=script&setup=true&lang=js"

import "./daily-verse-card.vue?vue&type=style&index=0&id=2a64973c&lang=css"

const __exports__ = script;

export default __exports__